export default "__VITE_ASSET__DsZkXtNN__"